import { create } from 'zustand';
import type { POSShift } from '@/types';

interface ShiftStore {
  openShift: POSShift | null;
  shiftJustClosed: boolean;
  pendingPrintShiftName: string | null;
  setOpenShift: (shift: POSShift | null) => void;
  clearOpenShift: () => void;
  setShiftJustClosed: (value: boolean) => void;
  setPendingPrintShiftName: (name: string | null) => void;
}

export const useShiftStore = create<ShiftStore>()((set) => ({
  openShift: null,
  shiftJustClosed: false,
  pendingPrintShiftName: null,
  // Only clear "just closed" when a new open shift is set; null (refetch after close) must keep it.
  setOpenShift: (shift) =>
    set({
      openShift: shift,
      ...(shift ? { shiftJustClosed: false as const } : {}),
    }),
  clearOpenShift: () => set({ openShift: null }),
  setShiftJustClosed: (value) => set({ shiftJustClosed: value }),
  setPendingPrintShiftName: (name) => set({ pendingPrintShiftName: name }),
}));
